var _g;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F25022",
    d: "M0 0h10.796v12.071H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4EF",
    d: "M0 13.929h10.796V26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7FBA00",
    d: "M12.457 0h10.796v12.071H12.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB900",
    d: "M12.457 13.929h10.796V26H12.457z"
  }))));
});
const SvgMicrosoft = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoft);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjQgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+TG9nb3NpZ248L3RpdGxlPgogICAgPGcgaWQ9IltORVddLeKAlC1PbmJvYXJkaW5nIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iU2lnbi11cC0tLUVtYWlsLS0tVmVyaWZpY2F0aW9uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODUwLCAtNDc3KSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IkNvbDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ3NSwgOTApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJDYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLCA5NykiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJBY3Rpb25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MCwgMjc1KSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJCVE4tQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjczLCAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iTG9nb3NpZ24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUyLCAxNSkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNGMjUwMjIiIHg9IjAiIHk9IjAiIHdpZHRoPSIxMC43OTYyNzc3IiBoZWlnaHQ9IjEyLjA3MTQyODYiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjMDBBNEVGIiB4PSIwIiB5PSIxMy45Mjg1NzE0IiB3aWR0aD0iMTAuNzk2Mjc3NyIgaGVpZ2h0PSIxMi4wNzE0Mjg2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iIzdGQkEwMCIgeD0iMTIuNDU3MjQzNSIgeT0iMCIgd2lkdGg9IjEwLjc5NjI3NzciIGhlaWdodD0iMTIuMDcxNDI4NiI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNGRkI5MDAiIHg9IjEyLjQ1NzI0MzUiIHk9IjEzLjkyODU3MTQiIHdpZHRoPSIxMC43OTYyNzc3IiBoZWlnaHQ9IjEyLjA3MTQyODYiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";